import { IPageIdentifier } from '@faire/web-api--source/indigofair/data/IPageIdentifier';
import { IRequestPaginationData } from '@faire/web-api--source/indigofair/data/IRequestPaginationData';

export namespace IGetSDUIFilteredComponentsRequest {
  /**
   * Return an instance of IGetSDUIFilteredComponentsRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IGetSDUIFilteredComponentsRequest>
  ): IGetSDUIFilteredComponentsRequest =>
    ({
      filter_keys: [],
      ...(partial ?? {}),
    }) as IGetSDUIFilteredComponentsRequest;
}

export interface IGetSDUIFilteredComponentsRequest {
  page_identifier: IPageIdentifier | undefined;
  /**
   * Component pagination param, assuming there will only be one
   * paginatable component within a certain section.
   * E.g. ["navigation_path:Accessories"]
   */
  filter_keys: Array<string>;
  pagination_data: IRequestPaginationData | undefined;
  /**
   * Return debug info in the response (only for employees and only for web).
   * Example: Retrieval and Ranking Info in product grid on category and search pages.
   */
  return_debug_info: boolean | undefined;
  /**
   * Enable FPS flow layout for the filtered components.
   */
  enable_f_p_s_flow_layout: boolean | undefined;
}
